import { type VariantProps } from 'class-variance-authority';
import {
  brandLogoContainerVariants,
  brandLogoIconVariants,
  brandLogoTextVariants,
} from '@/shared/constants/ui-variants';
import { cn } from '@/shared/lib/utils';
import { BrandLogoSize } from '@/shared/types/brandlogo.types';
import { MVLogo } from './mv-logo';

export interface BrandLogoProps extends VariantProps<
  typeof brandLogoContainerVariants
> {
  readonly size?: BrandLogoSize;
  readonly showText?: boolean;
  readonly showSlogan?: boolean;
  readonly className?: string;
}

/**
 * BrandLogo - Consistent branding component used across app and auth pages
 * Features: M+V combined logo representing Madi & Vladi, optional text, optional slogan
 */
export function BrandLogo({
  size = BrandLogoSize.Medium,
  showText = false,
  showSlogan = false,
  className,
}: BrandLogoProps) {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <div
        className={cn(brandLogoContainerVariants({ size }))}
        aria-label="Madi & Vladi Logo"
      >
        <MVLogo
          className={cn(brandLogoIconVariants({ size }))}
          aria-hidden={true}
        />
      </div>
      {(showText || showSlogan) && (
        <div className="flex flex-col">
          {showText && (
            <span className={cn(brandLogoTextVariants({ size }))}>
              Madi & Vladi
            </span>
          )}
          {showSlogan && (
            <span className="text-xs text-muted-foreground">
              Your Family. Organized.
            </span>
          )}
        </div>
      )}
    </div>
  );
}
